<template>
  <div class="journal">
    <section-header tag="h1" class="mt-5 mb-5" title="焦點文章" subtitle="Journal"/>
    <div class="article-list">
      <div class="row">
        <div class="col-xl-4 col-sm-6 mb-5" v-for="(journal, index) in journals" :key="index">
          <div class="border border-secondary">
            <router-link :to="`/w/journal/detail/${ (journal.link === '') ? journal.articleId : journal.link }`" class="text-decoration-none text-dark">
              <template v-if="journal.mobileImg">
                <div class="image d-none d-md-block" :style="util.getImageStyle(journal.originalImg)"></div>
                <div class="mobile-image d-md-none" :style="util.getImageStyle(journal.mobileImg)"></div>
              </template>
              <div v-else class="image" :style="util.getImageStyle(journal.originalImg)"></div>
              <div class="p-2">
                <div class="title mb-2">{{ journal.title }}</div>
                <div class="content mb-2" v-html="util.getHtmlText(journal.content)"></div>
                <div class="more mb-3 text-decoration-underline"><img src="@/assets/img/ic-step-divider.svg">read more......</div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <list-pagination :page="page" :limit="limit" :total="total" @page="onPageChanged" />
  </div>
</template>

<script>
import constant from '@/constant.js'
import util from '@/util.js'
import journalApi from '@/api/journal.js'
import { mapMutations } from 'vuex'
import SectionHeader from '@/components/SectionHeader.vue'
import ListPagination from '@/components/ListPagination.vue'

export default {
  name: 'Journal',
  components: {
    SectionHeader,
    ListPagination
  },
  data: function () {
    return {
      journals: [],
      total: 0,
      limit: 12
    }
  },
  computed: {
    util: function () {
      return util
    },
    page: function () {
      var ret = this.$route.query.page
      if (!ret) {
        ret = 0
      }
      return Number(ret)
    }
  },
  watch: {
    page: function (value) {
      this.refresh()
    }
  },
  mounted: function () {
    this.apiGetJournalTotal()
    this.apiGetJournals()
  },
  methods: {
    ...mapMutations([
      'signOut'
    ]),
    apiGetJournals: function () {
      var self = this
      var filter = {
        page: this.page,
        limit: this.limit
      }
      journalApi.getJournals(filter, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.journals = rspData
      })
    },
    apiGetJournalTotal: function () {
      var self = this
      journalApi.getJournalTotal(function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.total = rspData
      })
    },
    refresh: function () {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
      this.apiGetJournals()
    },
    onPageChanged: function (value) {
      this.$router.push(`/w/journal?page=${value}`)
    }
  }
}
</script>

<style scoped>
.image {
  width: 100%;
  padding-bottom: 60%;
  min-width: 200px;
  min-height: 200px;
}
.mobile-image {
  width: 100%;
  padding-bottom: 130%;
  min-width: 200px;
  min-height: 200px;
}
.title {
  font-family: 'Noto Serif TC', serif;
  font-size: 20px;
  font-weight: 700;
}
.content {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.more {
  font-size: 0.9rem;
}
.more img {
  width: 14px;
  height: 14px;
}
@media screen and (max-width: 767px) {
  .content {
    display: none;
  }
}
</style>
